export const soinsData = [
    {
        title: "Entretien",
        icon: "entretien-menager.svg",
        description: "Entretien du lieu de vie des animaux.",
    },
    {
        title: "Mise bas",
        icon: "mise-bas.svg",
        description: "Accompagnement et assistance lors de la mise bas des animaux.",
    },
    {
        title: "Éveil et soin des chiots et/ou chatons",
        icon: "soin-animaux.svg",
        description: "Programme d’éveil et de soins pour le bon développement des chiots et chatons.",
    },
    {
        title: "Premiers secours",
        icon: "premier-secours.svg",
        description: "Formation et interventions en premiers secours pour les animaux.",
    },
    {
        title: "Nourrissage",
        icon: "gamelle.svg",
        description: "Préparation et distribution des repas adaptés aux besoins des animaux.",
    },
    {
        title: "Accueil des clients",
        icon: "accueil-client.svg",
        description: "Prise en charge des clients et gestion de l’accueil.",
    },
    {
        title: "Gestion administrative",
        icon: "gestion-administrative.svg",
        description: "Organisation et gestion des tâches administratives liées aux activités.",
    },
    {
        title: "Promenades",
        icon: "chien.svg",
        description: "Sorties et promenades adaptées aux besoins des animaux.",
    },
    {
        title: "Proposition d'optimisation du bien-être des animaux",
        icon: "proposition.svg",
        description: "Conseils et recommandations pour améliorer le bien-être animal..",
        details: "\nÀ la demande du client"
    },
    {
        title: "Gestion des stagiaires/apprentis",
        icon: "stagiaire.svg",
        description: "Encadrement et suivi des stagiaires et apprentis en formation.",
        details: "\nL’ensemble des dommages matériels et/ou corporels provoqués par le stagiaire ou l’apprenti est sous la responsabilité de son maître de stage/apprentissage."
    },
 
];